import { useState } from 'react';

import { ResourceCostChartWidget } from './_components/ResourceCostChartWidget';
import { useWorkloadResourceCostChartData } from './_hooks/useWorkloadResourceCostChartData';
import { CPU_FIELDS } from './constants';

const CPU_COST_TOOLTIP_TEXT =
  'Cost per requested vCPU based on CPU compute spend divided by requested CPU cores.';

export const CpuCostChartWidget = () => {
  const [costRate, setCostRate] = useState<'hourly' | 'daily' | 'monthly'>(
    'daily'
  );
  const {
    data,
    averageCost,
    isLoading,
    error,
    refetch,
    timeZone,
    isRangeSupported,
  } = useWorkloadResourceCostChartData(costRate, CPU_FIELDS);

  return (
    <ResourceCostChartWidget
      title="CPU cost"
      testId="cpu-cost-card"
      metricLabel="Cost per requested vCPU"
      metricInfoTooltip={CPU_COST_TOOLTIP_TEXT}
      metricTestId="cpu-cost-metrics-box"
      failedToLoadTitle="Failed to load CPU cost"
      hasOfferingBreakdown
      costRate={costRate}
      onCostRateChange={setCostRate}
      data={data}
      averageCost={averageCost}
      isLoading={isLoading}
      error={error}
      refetch={refetch}
      timeZone={timeZone}
      isRangeSupported={isRangeSupported}
      chartTestId="cpu-cost-chart"
      tooltipTestId="cpu-cost-tooltip"
      unsupportedRangeTestId="cpu-cost-card-unsupported-range"
    />
  );
};
